import {Storage} from "./storage"

export const isMenuCollapse = new Storage('isMenuCollapse')

isMenuCollapse.setIsMenuCollapse = function(value) {
    this.set(value)
}

isMenuCollapse.getIsMenuCollapse = function() {
    return this.get()
}



// WEBPACK FOOTER //
// ./src/util/isMenuCollapse.js